export const executeCustomLogicCode = async(onCartUpdated?: () => void) => {
    try {
        const storeConfigStr = localStorage.getItem('storeConfiguration');
        if (storeConfigStr) {
            const storeConfig = JSON.parse(storeConfigStr);
            if (storeConfig?.data?.logic?.custom?.code) {
                const customCode = storeConfig.data.logic.custom.code;
                
                // Wrap the custom code with pc_data initialization
                const wrappedCode = `
                    try {
                        const cart = JSON.parse(localStorage.getItem('cart') || '{}');
                        const shippingMethods = JSON.parse(localStorage.getItem('shippingMethods') || '[]');
                        
                        ${customCode}
                        //update localStorage with the new cart
                        localStorage.setItem('cart', JSON.stringify(cart));
                        localStorage.setItem('shippingMethods', JSON.stringify(shippingMethods));

                        
                        mapShippingMethods(shippingMethods);
                    } catch (e) {
                        console.error('Error in custom logic code:', e);
                    }
                `;
                
                // Create a new script element
                const scriptElement = document.createElement('script');
                scriptElement.type = 'text/javascript';
                scriptElement.text = wrappedCode;
                // Append to document to execute
                document.body.appendChild(scriptElement);
                // Ejecutar callback después de actualizar localStorage
                if (typeof onCartUpdated === 'function') {
                    onCartUpdated();
                }
            }
        }
    } catch (error) {
        console.error('Error executing custom logic code:', error);
    }
}
